import CurrencyRates from "../components/CurrencyRates";
import DashboardLayout from "../components/layouts/DashboardLayout";
import { useAuth } from "../context/AuthContext";

const CurrencyRatesPage = () => {
  const { user } = useAuth();
  const type = user?.role === "admin" ? "admin" : "agent";

  return (
    <DashboardLayout type={type}>
      <div className="space-y-6 max-w-3xl" data-testid="currency-rates-page">
        <div>
          <h1 className="text-2xl font-bold text-gray-900 mb-1">Currency Rates</h1>
          <p className="text-gray-500">Live exchange rates to INR</p>
        </div>
        <CurrencyRates />
      </div>
    </DashboardLayout>
  );
};

export default CurrencyRatesPage;
